export enum MaintenanceStatusType {
  NormalOperation = "NormalOperation",
  ApplicationDown = "ApplicationDown",
  MaintenancePeriod = "MaintenancePeriod"
}